var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":_vm.buttonType,"icon":"el-icon-download","loading":_vm.loading},on:{"click":_vm.download}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }